



































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import MediaSlider from "@share/presentation/components/MediaSlider.vue";
import {SimpleSlider} from "@share/presentation/sliders/SimpleSlider";
import {FluentSlider} from "@share/presentation/sliders/FluentSlider";
import {GoToParams} from "@share/presentation/types/GoToParams";
import BottomPartSwitcher from "@share/presentation/components/BottomPartSwitcher.vue";
import {CurrentPresentation} from "@api/models/interfaces/web-conference/CurrentPresentation";
import {SlidesService} from "@share/presentation/data/SlidesService";
import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import {getBackend} from "@service/router/getters";
import {isCurrentPresentationChanged} from "@share/web-conferences/helpers/slides/CurrentPresnetationComporator";
import {getImageUrl} from "@common/ImageUrlHelper";
import AudiencePresentationViewer from "@share/presentation/components/AudiencePresentationViewer.vue";

@Component({
    name: "Presentation",
    components: {AudiencePresentationViewer, BottomPartSwitcher, MediaSlider}
})
export default class Presentation extends Vue {
    @Prop() currentPresentation: CurrentPresentation;
    @Prop() schemaId: string;
    @Prop() objectId: string;

    slidesService: SlidesService | null = null;

    topSliderRefName = 'topSlider';
    bottomSliderRefName = 'bottomSlider';

    topSlider = new SimpleSlider();
    bottomSlider = new FluentSlider();
    showBottomPart = false;
    isMoved = false;

    created() {
        this.slidesService = new SlidesService(
            this.$repositories.get(RepositoryFabric.WEB_CONFERENCE_SLIDES),
            this.schemaId,
            this.objectId,
            this.$store
        );

        if (this.currentPresentation && this.isCurrentUserThePresenter) {
            this.slidesService.fetchSlides(this.currentPresentation.data.slidesId);
        }
        else {
            this.slidesService.isLoaded = true;
        }
    }

    get isCurrentUserThePresenter() {
        return this.currentPresentation?.userId == this.$store.state.session.userId;
    }

    get backend() {
        return getBackend(this.$route.params.backend)
    }

    get slides() {
        if (this.slidesService?.slides && this.slidesService?.slides.fileIds) {
            return this.slidesService?.slides.fileIds.map(item => getImageUrl(this.backend, item));
        }
        return [];
    }

    get currentSlideIndex() {
        return this.slidesService?.slides?.fileIds
            .findIndex(item => item == this.currentPresentation.data.currentSlideFileId);
    }

    get currentIndex() {
        return this.topSlider.state?.index ?? 0;
    }

    @Watch('currentPresentation')
    onCurrentPresentationChanged(newValue: CurrentPresentation, oldValue: CurrentPresentation) {
        if (this.isMoved) {//means that this user is the one who moved the slider
            this.isMoved = false;
            return;
        }
        if (
            this.isCurrentUserThePresenter &&
            isCurrentPresentationChanged(newValue, oldValue)
        ) {
            this.goToCurrentSlideIndex();
        }

    }

    goToCurrentSlideIndex() {
        if (this.currentSlideIndex != undefined && this.currentSlideIndex >= 0) {
            this.onBottomSelected(this.currentSlideIndex, false);
            this.onTopMoved(this.currentSlideIndex, false);
        }
    }

    emitChanged(index: number) {
        this.$emit('changed', this.slidesService?.getFileIdByIndex(index));
        this.isMoved = true;
    }

    onTopMoved(index: number, emitChanged = true) {
        if (this.$refs[this.bottomSliderRefName]) {
            (this.$refs[this.bottomSliderRefName] as any).goTo({
                index,
                setIndex: true
            } as GoToParams);
        }
        if (emitChanged) {
            this.emitChanged(index);
        }
    }

    onBottomSelected(index: number, emitChanged = true) {
        if (this.$refs[this.topSliderRefName]) {
            (this.$refs[this.topSliderRefName] as any).goTo({
                index: index,
                setIndex: true
            } as GoToParams);
        }
        if (emitChanged) {
            this.emitChanged(index);
        }
    }

    switchBottomPart() {
        if (this.isCurrentUserThePresenter) {
            this.showBottomPart = !this.showBottomPart;
        }
    }
}
